import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import MainLayout from "@/components/layout/MainLayout";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import MangaDetailPage from "@/pages/manga/page";
import ReaderPage from "@/pages/reader/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:categoryId", element: <CategoryPage /> },
      { path: "manga/:mangaId", element: <MangaDetailPage /> },
      { path: "reader/:mangaId/:chapterIndex", element: <ReaderPage /> },
      { path: "about", element: <AboutPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;